export default __webpack_public_path__ + "static/media/Close_Normal.9950a11e.svg";